import { Selector } from 'controllers/tied'

type SelectedMultasValueSelector = Selector<number>
/** Total value of multas selected by the user in the list-multas tab.  */
export const broadcast_selected_multas_value: SelectedMultasValueSelector =
  selected_multas_value => selected_multas_value